<template>

    <div class="scope-of-works-task" v-if="task">
        <div class="task-info">
            <strong>{{ task.reference }}:</strong> {{ task.title }}
        </div>
        <div class="children" v-if="task.children.length">
            <sow-looper :items="task.children"></sow-looper>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['task'],
    }
</script>

<style lang="scss" scoped>
    .children {
        padding-left: 1em;
    }

    .task-info {
        @include clearfix();
        padding: 1em;
        background-color: #e7e7e7;
        border-radius: $standardBorderRadius;
        display: block;
        margin: 0.5em 0;
        font-size: 17px;
        color: $brand;
        font-weight: 300;
        strong {
            font-weight: 700;
        }
    }
</style>
